import api from "../../../api";

export default {
  async getDeviceEvents({ commit }, obj) {
    commit("REQUEST_DEVICE_EVENTS");
    commit("SET_LOADING", true, { root: true });
    try {
      const response = await api.getDeviceEvents(obj);
      commit("SUCCESS_REQUEST_DEVICE_EVENTS", response);
      return response.body;
    } catch (err) {
      commit("FAILURE_REQUEST_DEVICE_EVENTS");
      return [];
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },

  async getEvents({ commit }, filter) {
    commit("REQUEST_EVENTS");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_EVENTS",
        await api.getEvents(filter)
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_EVENTS");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getEventsReport({ commit }, filter) {
    commit("REQUEST_EVENTSREPORT");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_EVENTSREPORT",
        await api.getEventsReport(filter)
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_EVENTSREPORT");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async deleteEvent({ commit }, id) {
    commit("REQUEST_DELETE_EVENT");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_DELETE_EVENT",
        await api.deleteEvent(id)
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_DELETE_EVENT");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async updateEvent({ commit }, item ) {
    commit("REQUEST_UPDATE_EVENT");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_UPDATE_EVENT",
        await api.updateEvent(item)
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_UPDATE_EVENT");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async createEvent({ commit }, item ) {
    commit("REQUEST_CREATE_EVENT");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_CREATE_EVENT",
        await api.createEvent( item )
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_CREATE_EVENT");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
